/**
 * Reusable check icon used across pricing plan cards and add-on cards.
 */
interface CheckIconProps {
  color: string;
  size?: 'sm' | 'md';
}

export function CheckIcon({ color, size = 'md' }: CheckIconProps) {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : 'h-6 w-6';

  return (
    <svg
      className={sizeClass}
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
}
